/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */

/**
 * @module PrivID
 */

import { detect } from 'detect-browser';
import {
  isLoad,
  getDebugType,
  getIsSIMD,
  iOS,
  getUrlParameter,
  printLogs,
  checkPackageSupport,
  loadAntispoof,
} from './utils';
import { WasmVersion } from './types';
import { clearCache, clearDB } from './dbUtils';

import { apiKey, wasmUrl, wasmModule, setEnvVariables, cacheConfig } from './envUtils';

let isSimd: boolean | null = null;
let moduleLoaded = false;
let antiSpoofLoaded = false;

const debugType = getDebugType();

printLogs('debug_type', debugType, debugType);

/**
 * This function load the wasm module
 * @category Utils
 */
export const loadPrivIdModule = async function (
  api_url: string | null = null,
  api_key: string | null = null,
  api_orchestration_url: string | null = null,
  wasm_url: string | null = null,
  wasm_module: WasmVersion | null = null,
  cache_config: boolean | null = null,
  liveness: boolean | null = false,
) {
  try {
    const supportResult = await checkPackageSupport();

    if (!supportResult.support) {
      return supportResult;
    }

    setEnvVariables(api_key, api_url, api_orchestration_url, wasm_url, wasm_module, cache_config);
    const clearCacheParam = getUrlParameter('clear_cache', 'false');
    const cacheAge = localStorage.getItem('cacheAge');

    if (!cacheAge) {
      localStorage.setItem('cacheAge', Date.now().toString());
    }

    if ((cacheAge && Date.now() - Number(cacheAge) > 24 * 60 * 60 * 1000) || clearCacheParam === 'true') {
      printLogs('------clearingCache------', '', debugType);

      await clearDB();
      localStorage.clear();
      localStorage.setItem('cacheAge', Date.now().toString());
    }
    if (moduleLoaded) return { support: true };
    const hasSIMD: boolean = await getIsSIMD();
    printLogs('=====> is SIMD or NOT SIMD?', hasSIMD, debugType);
    printLogs('===> is IOS', iOS(), debugType);
    printLogs('==> browser? ', detect(), debugType);
    const { name: browserName, os } = detect();
    if (iOS() || os === 'iOS' || (os === 'Mac OS' && browserName !== 'chrome')) {
      isSimd = false;
    } else {
      isSimd = hasSIMD;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const loaded = await isLoad(isSimd, wasmUrl, apiKey, wasmModule, debugType, cacheConfig, liveness);
    printLogs('------loaded------', loaded, debugType);
    moduleLoaded = loaded === 'Loaded';

    return supportResult;
  } catch (e) {
    return { support: false, message: 'Unable to load wasm' };
  }
};

// eslint-disable-next-line consistent-return
export const loadAntiSpoofModules = async () => {
  try {
    if (!antiSpoofLoaded) {
      const result = await loadAntispoof(isSimd);
      antiSpoofLoaded = result;
      return result;
    }
  } catch (e) {
    //
    return false;
  }
};

export const isModuleLoaded = () => moduleLoaded;

export const isAntispoofLoaded = () => antiSpoofLoaded;

export * from './apiUtils';
export { clearDB, clearCache } from './dbUtils';
export * from './voiceModule';
export * from './faceModule';
export { convertCroppedImage, checkPackageSupport } from './utils';
